import * as Loadable from 'react-loadable'

import { getConfigBySite } from '../../../config/sites'
import { selectItemCountForCategory } from '../../../common/selectors/categories'
import { IPageComponent } from '../../../typings/pageComponent'
import LoadingCover from '../../components/loadingCover'
import { getSearchLocationParams } from '../../../common/utils/location'

import {
  fetchCategoryPageData,
  onBeforeCategoryPageView
} from '../../../common/actions/categoryPage'

const CategoryPageLoadableContainer = (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "categoryPage" */ './categoryPageContainer'),
  loading: LoadingCover,
  webpack: () => [require.resolveWeak('./categoryPageContainer')],
  modules: ['./categoryPageContainer']
}) as IPageComponent<any>

CategoryPageLoadableContainer.onBeforePageView = ({ store }) => {
  return store.dispatch(onBeforeCategoryPageView())
}

CategoryPageLoadableContainer.loadData = ({
  store,
  location,
  apiAppUrlPrefix,
  routeMatch
}) => {
  const state = store.getState()
  const {
    common: { currentSite }
  } = state

  const locationParams = getSearchLocationParams({
    location,
    routeMatch,
    currentSite
  })

  const itemCount = selectItemCountForCategory(state, locationParams.category)
  const minItemCountForCategoryPage = getConfigBySite(
    currentSite,
    'minimum_items_for_category_page'
  )

  const isCategoryAllPage = !locationParams.category
  const hasCategoryPageData =
    isCategoryAllPage || itemCount > minItemCountForCategoryPage
  const isCategoryPageEnabled = getConfigBySite(
    currentSite,
    'displayCategoryPage'
  )

  const shouldFetchCategoryPageData =
    hasCategoryPageData && isCategoryPageEnabled

  if (shouldFetchCategoryPageData) {
    return store.dispatch(
      fetchCategoryPageData({ location, apiAppUrlPrefix, locationParams })
    )
  }

  return Promise.resolve()
}

export default CategoryPageLoadableContainer
